





































import { Component, Vue }     from 'vue-property-decorator';

import constants              from '@/constants';
import routerHelper           from '../router/helper';

import Map                    from '@/components/map/Map.vue';
import MapTrayDesktop         from '@/components/map/MapTrayDesktop.vue';
import MapTrayMobile          from '@/components/map/MapTrayMobile.vue';

import GeolocationErrorModal  from '@/components/GeolocationErrorModal.vue';
import { Route }              from 'vue-router';

@Component({
  name: 'Main',
  components: {
    Map,
    MapTrayDesktop,
    MapTrayMobile,
    GeolocationErrorModal
  }
})

export default class Main extends Vue {
  get activeSiteReference() {
    return this.$store.state.activeSite.reference;
  }

  get isDesktop() {
    return this.$store.state.uiState.isDesktop;
  }

  /**
   * Has a back route means
   * - we're on a site mini detail page
   * - that we got to from a search results page
   * - and we'll show a back button in the search input
   *
   * [new] ORRR...
   * -
   */
  get hasBackRoute(): boolean {
    if (this.$store.state.uiState.isSiteRoute) {
      return (this.$store.state.activeSite.reference.siteNumber === this.$store.state.uiState.siteNumberWithBackRoute);
    }
    return false;
  }

  get backRoute() {
    return this.$store.state.uiState.backRoute;
  }


  /**
   * "State context" means either
   * - currently showing a site (mini detail or detail)
   * - currently showing a search result route
   *
   * --> in both cases, it ultimately means there's something to display in the search bar, which can be closed
   */
  get hasStateContext() {
    return this.$store.state.uiState.isSearchResultsRoute || this.$store.state.uiState.isSiteRoute;
  }

  /**
   * The "state context" (text) to show in the search bar, or an empty string if there's nothing to show
   */
  get stateContextTitle() {
    if (this.$store.state.uiState.isSearchResultsRoute) {
      const terms = this.$store.state.searchResults.currentSearch.searchTerms;
      return terms.join(" ");

    } else if (this.$store.state.uiState.isSiteRoute) {
      let siteName = this.$store.state.activeSite.reference.siteName;

      siteName =  siteName.toLowerCase()
                  .split(' ')
                  .map((s: string) => s.charAt(0).toUpperCase() + s.substring(1))
                  .join(' ');
      return siteName;
    }
    return '';
  }

  mounted() {

    // Initialize isDesktop state flag
    this.setIsDesktop();
    this.setIsShortMobile();
    this.setSafariVhWorkaroundCssVariable();

    // Make a resize observer to tell JS & reactive state when isDesktop should change
    const resizeObserver = new ResizeObserver(() => {
      this.setIsDesktop();
      this.setIsShortMobile();
    });
    resizeObserver.observe(document.querySelector('body')!);


    // TODO: doc
    window.addEventListener('resize', () => {
      this.setSafariVhWorkaroundCssVariable();
    })

  }

  //
  // Route Guards
  //

  /**
   * Triggers any actions required to fetch data for the given route, when this component
   * is first instantiated (on initial page load only)
   */
  beforeRouteEnter(to: Route, from: Route, next: Function) {
    console.log('beforeRouteEnter running')
    next((vm: any) => {

      // Happens in callback like this because *this* isn't defined when beforeRouteEnter
      // runs ('vm' is 'this')
      vm.beforeRoute_Helper(to, from);
    });
  }

  /**
   * Triggers any actions required to fetch data for the given route, when this component
   * is reused (on every navigation after initial page load)
   */
  beforeRouteUpdate(to: Route, from: Route, next: Function) {
    console.log(`beforeRouteUpdate running: from ${from.path} to ${to.path} `)
    this.beforeRoute_Helper(to);

    next();
  }

  /**
   * Does all the heavy lifting associated with route switching:
   * - fires XHRs to load sites and do searches
   * - updates page title | desc | canonical
   *
   * Feels weird that it's in this file, but also that it's the Vue way, given how route
   * guards work. See https://router.vuejs.org/guide/advanced/navigation-guards.html
   */
  async beforeRoute_Helper(to: Route) {

    switch(to.name) {
      // IMPORTANT: on first page load, to.name is undefined. this fixes a bug that was in the
      // product for a long time...
      case undefined:
      case constants.RouteNames.Main:
        await this.$store.dispatch('setIsSearchResultsRoute', false);
        await this.$store.dispatch('setIsSiteRoute', false);

        this.updatePageMeta({
            title: routerHelper.getHomePageTitle(),
            description: routerHelper.getHomePageDescription(),
            canonical: routerHelper.getCanonicalBase()
          }
        );

        // Force open tray in Desktop
        // TODO: fork this variable for mobile vs desktop
        if (this.$store.state.uiState.isDesktop) {
          this.$store.dispatch('setIsTrayOpen', true);
        }
        break;

      case constants.RouteNames.Search:

        await this.$store.dispatch('setIsSearchResultsRoute', true);
        await this.$store.dispatch('setIsSiteRoute', false);

        const query = to.params.query;
        await this.$store.dispatch('doKeywordSearch', query);

        // Add to search MRU
        this.$store.dispatch('setRecentSearch', query);

        this.updatePageMeta({
            title: routerHelper.getSearchPageTitle(query),
            description: routerHelper.getSearchPageDescription(query),
            canonical: `${routerHelper.getCanonicalBase()}${this.$route.path}`
          }
        );

        // Force open tray
        this.$store.dispatch('setIsTrayOpen', true);
        break;

      case constants.RouteNames.NearLocation:
        await this.$store.dispatch('setIsSearchResultsRoute', false);
        await this.$store.dispatch('setIsSiteRoute', false);

        await this.$store.dispatch('setUserLocation', to.query);

        this.$store.dispatch("setSearchResults", this.$store.state.mapSearchResults.currentSearch);

        this.updatePageMeta({
            title: routerHelper.getSearchPageTitle(`location lat: ${to.query.lat}, lon: ${to.query.lng}`),
            description: routerHelper.getLocationSearchPageDescription(`location lat: ${to.query.lat}, lon: ${to.query.lng}`),
            canonical: `${routerHelper.getCanonicalBase()}${this.$route.path}`
          }
        );

        // Force open tray
        this.$store.dispatch('setIsTrayOpen', true);

        break;

        // return this.$store.state.searchResults.currentSearch.siteRefs;

        // MUST BE PART OF THE ROUTE!!!!! SO IT'S DEEP LINKABLE!

        // Make the map search results the search results!!!
        //
        // TODO: this needs to get triggered AFTER the xhr returns, which is in turn triggered
        //       by this route... however, the decision point for whether or not to do this for a
        //       map search belongs here. I think.
        //
        // But actually maybe I just put this in the map...
        //
        // The routing logic is bleeding out into components and I really don't like it.

      case constants.RouteNames.Detail:
      case constants.RouteNames.MiniDetail:

        await this.$store.dispatch('setIsSearchResultsRoute', false);
        await this.$store.dispatch('setIsSiteRoute', true);

        // Two flows:
        //
        // 1. pageload directly to /site/12345678/
        //    - we need to get a siteReference first from OSF's API
        //    - then we get the data
        //
        // [NOT IMPLEMENTED] 2. any other way of getting to /site/12345678
        //    - we already have a siteReference
        //    - so we save an XHR, make the site, and get the data
        //
        // TODO IMPLEMENT #2
        const siteNumber = to.params.siteNumber;

        // Workaround bug caused by bad sitemaps without leading 0's on Site Numbers...
        //
        // ... Remove this if/when they ever get removed from Google's index
        if (to.params.siteNumber.length === 7) {
          const fixedTo = { ...to };
          fixedTo.params.siteNumber = `0${to.params.siteNumber}`
          this.$router.push(fixedTo);
          break;
        }

        // Only fetch data if site changed
        if (this.activeSiteReference.siteNumber !== siteNumber) {
          await this.$store.dispatch('setIsLoadingSite', true);
          console.log('Main: setIsLoadingSite = true')

          const siteReference = await this.$store.dispatch('loadSiteReference', siteNumber);
          this.updatePageMeta({
              title: routerHelper.getSitePageTitle(siteReference),
              description: routerHelper.getSitePageDescription(siteReference.siteNumber, siteReference.state),
              canonical: `${routerHelper.getCanonicalBase()}${this.$route.path}`
            }
          );

          // Then load all the USGS data
          await this.$store.dispatch('loadSiteData', siteReference);

          // Turn off site loading spinners
          await this.$store.dispatch('setIsLoadingSite', false);
          console.log('Main: setIsLoadingSite = false');

          // Add site to MRU
          this.$store.dispatch('addRecentSite', siteReference);
        } else {
            // IMPORTANT: FIXES LONG-TIME SEO BUG - Always update the canonical!!!
            const siteReference = this.$store.state.activeSite.reference;
            this.updatePageMeta({
                title: routerHelper.getSitePageTitle(siteReference),
                description: routerHelper.getSitePageDescription(siteReference.siteNumber, siteReference.state),
                canonical: `${routerHelper.getCanonicalBase()}${this.$route.path}`
              }
            );
        }
        break;
    }
  }

  /**
   * Update the current pages' title | description | canonical href with the given values
   */
  updatePageMeta({ title, description, canonical } : { title: string, description: string, canonical: string }) {
    document.title = title;

    const canonicalTag = document.querySelector('link[rel=canonical]');
    if (canonicalTag) {
      canonicalTag.setAttribute('href', canonical);
    }

    const descriptionTag = document.querySelector('meta#meta-description');
    if (descriptionTag) {
      descriptionTag.setAttribute('content', description);
    }
  }

  /**
   * Set the isDesktop global state flag
   */
  setIsDesktop() {
    const nextIsDesktop = (window.innerWidth >= constants.DesktopMinWidth) ? true : false;
    if (this.$store.state.uiState.isDesktop !== nextIsDesktop) {
      this.$store.dispatch('setIsDesktop', nextIsDesktop);
    }
  }

  /**
   * Set the isShortMobile global state flag
   */
  setIsShortMobile() {
    const nextIsShortMobile = (window.innerWidth >= constants.DesktopMinWidth) ? true : false;
    if (this.$store.state.uiState.nextIsShortMobile !== nextIsShortMobile) {
      this.$store.dispatch('setIsShortMobile', nextIsShortMobile);
    }
  }

  // see https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
  setSafariVhWorkaroundCssVariable() {

    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    const computedVh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${computedVh}px`);
  }

  /**
   * Handle geolocation failures by showing the user an error modal with tips on how to fix
   */
  handleGeolocationError() {
    (this.$refs.geolocationErrorModal as GeolocationErrorModal).show();
  }


};

